export const secondProducts = [
  {
    icon: "//files.authing.co/authing-website/home-0830-4-icon-12.png",
    title: "企业微信、钉钉、飞书等协作工具",
    subtitle:
      "通过企业主流协同办公应用，将组织架构体系打通，统一员工身份、实现单点登录",
    img: "//files.authing.co/authing-website/home-0830-s-4-4.png",
  },
  {
    icon: "//files.authing.co/authing-website/home-0830-4-icon-13.png",
    title: "北森，薪人薪事等 EHR",
    subtitle:
      "集成企业常见 EHR 系统，统一员工身份源，自动化同步数据、实现细粒度的授权管理",
    img: "//files.authing.co/authing-website/home-0830-s-4-4.png",
  },
  {
    icon: "//files.authing.co/authing-website/home-0830-4-icon-14.png",
    title: "AD, LDAP 等目录服务",
    subtitle:
      "Authing 支持 OIDC、OAuth2.0、SAML、LDAP 等标准协议，可作为 Identity Provider 或 Service Provider",
    img: "//files.authing.co/authing-website/home-0830-s-4-4.png",
  },
  {
    icon: "//files.authing.co/authing-website/home-0830-4-icon-15.png",
    title: "Gitlab, Jenkins 等开发工具",
    subtitle:
      "Authing 也支持 GitLab、Jira、飞连、JumpServer、Zabbix 等，帮助提升开发者效率",
    img: "//files.authing.co/authing-website/home-0830-s-4-4.png",
  },
];
